"use client";
import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
const COMPONENT_NAME = "SIGN_IN_BUTTON";
const SignInButton = ({
  productTitleId,
  pdpNavigationUrl,
  buttonStyles,
  productInfoData,
  signinbuttonlabel,
  onClick
}) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-describedby": productTitleId,
      onClick: () => onClick(pdpNavigationUrl || ""),
      sx: buttonStyles,
      uniqueId: `${COMPONENT_NAME}_${productInfoData.partNumber}`,
      variant: "primary",
      children: signinbuttonlabel
    }
  );
};
export {
  SignInButton
};
